import { pushOrReplace, set } from '@imcc/utilities';
import { byProperties } from '../../arrays/by-properties';
import { presentAggregations } from '../present-aggregations';

function mergeValues(oldValues, newValues) {
  const updatedOldValues = oldValues.map((oldValue) => ({ ...oldValue, count: 0 }));

  return newValues.reduce((mergedValues, newValue) => {
    const isEquivalent = (oldValue) => oldValue.value === newValue.value;

    return pushOrReplace(mergedValues, newValue, isEquivalent);
  }, updatedOldValues);
}

function mergeAggregations(oldAggregations, newAggregations) {
  return newAggregations.map((newAggregation) => {
    const { name } = newAggregation;
    const oldAggregation = oldAggregations.find(byProperties({ name }));

    if (oldAggregation) {
      const { values: oldValues } = oldAggregation;
      const { values: newValues } = newAggregation;

      return { ...oldAggregation, values: mergeValues(oldValues, newValues) };
    }

    return { ...newAggregation, values: newAggregation.values };
  });
}

export function updateAggregationsReducer(state, action) {
  const { indexName, aggregations: newAggregations } = action;
  const { aggregations: oldAggregations } = state.tabs[action.indexName];
  const aggregations = mergeAggregations(oldAggregations, newAggregations);
  const newState = { ...state, indexName };
  const value = presentAggregations(aggregations);

  return set(newState, ['tabs', indexName, 'aggregations'], value);
}
